export const RATING_DESCRIPTIONS = {
  1: 'This lease is well above market rates and offers little value for the cost. In most cases, there are better alternatives available.',
  2: 'This lease costs more than most comparable offers. It may still make sense for your specific needs, but the value is weak for the price.',
  3: "This lease deal reflects standard pricing relative to the vehicle's MSRP. It's not a strong deal, but it's also not especially expensive compared to similar leases.",
  4: "This lease deal is competitively priced relative to the vehicle's MSRP, though it's not quite as strong as the most aggressive deals.",
  5: 'This lease deal offers exceptional value relative to the vehicle’s MSRP.',
};

export const RATING_LABELS = {
  1: 'Poor',
  2: 'Below Average',
  3: 'Typical',
  4: 'Good',
  5: 'Excellent',
};
